import type { FunctionComponent } from 'react';
import { useSearchModalsContentQuery } from '../../../graphql/useSearchModalsContentQuery';
import { CommuteAndLocationModal } from '../../../components/CommuteAndLocationModal/CommuteAndLocationModal';
import { getSearchFlowFromUrl } from '../../../helpers/queryStringHelpers/queryStringHelpers';
import { useRecentSearches } from '@property.com.au/ui-kit';
import { useAccountContext } from '../../../app-kit/contexts/AccountContext/AccountContext';
import { useSearchLandingPageContext } from '../../contexts/SearchLandingPageContext/SearchLandingPageContext';

interface SearchLandingPageCommuteAndLocationModalWithDataProps {
  onClose: () => void;
}

export const SearchLandingPageCommuteAndLocationModalWithData: FunctionComponent<
  SearchLandingPageCommuteAndLocationModalWithDataProps
> = ({ onClose }) => {
  const data = useSearchModalsContentQuery()?.data?.searchModalsContent?.modals?.commuteAndLocation;
  const { searchQuery } = useSearchLandingPageContext();

  const { isSignedIn } = useAccountContext();
  const { saveRecentLocationSearch } = useRecentSearches({ isSignedIn });

  const flow = getSearchFlowFromUrl(searchQuery);

  if (!data) return null;

  return (
    <CommuteAndLocationModal
      onClose={onClose}
      saveRecentLocationSearch={saveRecentLocationSearch}
      searchQuery={searchQuery}
      initialScreen={flow === 'commute' ? 'COMMUTE' : 'LOCATION'}
      locationScreen={data.locationScreen}
      commuteScreen={{
        ...data.commuteScreen,
      }}
    />
  );
};
